export default __webpack_public_path__ + "ada48fde2ca8b9ac75abca620cacc137.png";